/**
 * Prefer storefront availability (lot/package) potency over Product-row defaults when both exist.
 */
const CANNABIS_FIELD_KEYS = [
  'strain',
  'thcPercent',
  'thcMg',
  'thcMin',
  'thcMax',
  'thcUom',
  'cbdPercent',
  'cbdMg',
  'cbdMin',
  'cbdMax',
  'cbdUom',
  'cbnPercent',
  'cbnMg',
  'cbgPercent',
  'cbgMg',
  'totalTerpenePercent',
  'dominantTerpene',
] as const;

function isMeaningful(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  return true;
}

export function mergeCannabisFieldsFromAvailability(product: any, availability: any): any {
  if (!product) return product;
  if (!availability) return product;
  const out = { ...product };
  for (const k of CANNABIS_FIELD_KEYS) {
    const v = (availability as Record<string, unknown>)[k];
    if (isMeaningful(v)) {
      (out as Record<string, unknown>)[k] = v;
    }
  }
  return out;
}
